import { useState } from "react";
import {
  DEFAULT_BOOKING_VAR,
  DEFAULT_LOCAL_STORAGE_KEY_FOR_BOOKING_STATE,
} from "../constants";
import useLocalStorage from "./useLocalStorage";

const useBookingContext = (): BookingState => {
  const { getValue, setValue } = useLocalStorage<BookingVars>();
  const [bookingState, setBookingState] = useState<BookingVars>(
    getValue(DEFAULT_LOCAL_STORAGE_KEY_FOR_BOOKING_STATE) ?? DEFAULT_BOOKING_VAR
  );

  const updateBookingState = (bookingState: BookingVars) => {
    setBookingState(bookingState);
    setValue(DEFAULT_LOCAL_STORAGE_KEY_FOR_BOOKING_STATE, bookingState);
  };

  return { bookingState, updateBookingState };
};

export default useBookingContext;
